import axios from 'axios';
import {serverUrl} from "../../../config";
export default class PropositionService{
  static getPropostionsAndContracts(status, page=1){
    return axios.get(serverUrl+`api/broker/home/get-propositions/${status}/${page}`);
  }
}
